"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeDocument = decodeDocument;
const decoded_types_1 = require("../decoded-types");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const decode_page_document_1 = require("./decode-page-document");
const decode_master_document_1 = require("./decode-master-document");
function decodeDocument(doc, context) {
    const warnings = [];
    const raw = doc.nodes[0];
    if (doc.nodes.length < 3) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `expected at least 3 top-level nodes, got ${doc.nodes.length}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path: '/document',
        });
        return makeUnknownDocument(doc, NaN, NaN, warnings);
    }
    const versionAtom = doc.nodes[0];
    const typeAtom = doc.nodes[1];
    const root = doc.nodes[2];
    if (versionAtom.type !== 'atom' || !versionAtom.content.startsWith('version')) {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `expected version atom, got ${versionAtom.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path: '/document/nodes[0]',
        });
        return makeUnknownDocument(doc, NaN, NaN, warnings);
    }
    if (typeAtom.type !== 'atom') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `expected rootTypeCode atom, got ${typeAtom.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path: '/document/nodes[1]',
        });
        return makeUnknownDocument(doc, NaN, NaN, warnings);
    }
    if (root.type !== 'container' && root.type !== 'econtainer') {
        warnings.push({
            type: decoded_types_1.DecodeWarningType.InvariantViolation,
            message: `expected root container, got ${root.type}`,
            severity: sigma_engine_shared_1.BoundaryLevel.Error,
            path: '/document/nodes[2]',
        });
        return makeUnknownDocument(doc, NaN, NaN, warnings);
    }
    const schemaVersion = parseInt(versionAtom.content.replace(/^version\s*/, ''), 10);
    const rootTypeCode = parseInt(typeAtom.content, 10);
    const ctx = context ?? { instanceHashMap: null, netHashMap: null, pageNum: null };
    if (rootTypeCode === 4) {
        const body = (0, decode_page_document_1.decodePageDocument)(root, '/page', warnings, ctx.instanceHashMap, ctx.pageNum);
        return {
            kind: 'document',
            schemaVersion,
            rootTypeCode,
            body,
            warnings,
            raw,
        };
    }
    if (rootTypeCode === 3) {
        const body = (0, decode_master_document_1.decodeMasterDocument)(root, '/master', warnings);
        return {
            kind: 'document',
            schemaVersion,
            rootTypeCode,
            body,
            warnings,
            raw,
        };
    }
    warnings.push({
        type: decoded_types_1.DecodeWarningType.UnknownTypeCode,
        message: `unrecognized rootTypeCode=${rootTypeCode}`,
        severity: sigma_engine_shared_1.BoundaryLevel.Warning,
        path: '/document',
    });
    return makeUnknownDocument(doc, schemaVersion, rootTypeCode, warnings);
}
function makeUnknownDocument(doc, schemaVersion, rootTypeCode, warnings) {
    const root = doc.nodes[2] ?? doc.nodes[0];
    const body = {
        kind: 'unknown-document',
        rootTypeCode,
        raw: root,
    };
    return {
        kind: 'document',
        schemaVersion,
        rootTypeCode,
        body,
        warnings,
        raw: root,
    };
}
void null;
//# sourceMappingURL=decode-document.js.map